import moment, { Moment } from 'moment';

export const getDate = (data: unknown): Moment => {
    const tz = 0;
    let minutes: number | void;
    if (typeof data === 'number') minutes = data;
    else if (typeof data === 'string') minutes = parseInt(data, 10);
    const date = moment()
        .set({ hour: 0, minute: 0 })
        .add(typeof minutes === 'number' ? minutes + tz : 0, 'm');
    return date;
};
export const encodeDate = (date?: Moment): number => {
    const tz = 0;
    const minutes = moment(date).minutes();
    const hours = moment(date).hours();
    const result = hours * 60 + minutes - tz;
    return result < 0 ? 1440 + result : result;
};
